import React from 'react';
import { AppButton, AppModal, AppSpin, AppTypography } from '@/components/atoms';
import type { InsurerAttention } from '../types';

type AttachmentKey = 'attachment1' | 'attachment2' | 'attachment3' | 'attachment4' | 'attachment5';

interface Props {
  isOpen: boolean;
  loading: boolean;
  attention?: InsurerAttention;
  onClose: () => void;
  onDownloadAttachment: (attachmentKey: AttachmentKey) => void;
}

const attachmentItems: Array<{ key: AttachmentKey; label: string }> = [
  { key: 'attachment1', label: '添付ファイル①' },
  { key: 'attachment2', label: '添付ファイル②' },
  { key: 'attachment3', label: '添付ファイル③' },
  { key: 'attachment4', label: '添付ファイル④' },
  { key: 'attachment5', label: '添付ファイル⑤' },
];

const AttachmentRow: React.FC<{
  label: string;
  filename: string | null | undefined;
  onDownload: () => void;
}> = ({ label, filename, onDownload }) => (
  <div className="flex items-center gap-2">
    <AppTypography.P className="whitespace-nowrap">{label}</AppTypography.P>
    {filename ? (
      <div className="flex-1 min-w-0">
        <AppButton
          type="link"
          onClick={onDownload}
          className="!p-0 !h-auto text-blue-600 hover:text-blue-700 underline break-words whitespace-normal w-full text-left"
        >
          <i className="mr-2 fa fa-download" />
          <span className="break-words">{filename}</span>
        </AppButton>
      </div>
    ) : (
      <AppTypography.Text className="text-sm text-gray-400">-</AppTypography.Text>
    )}
  </div>
);

export const InsurerAttentionDetailModal: React.FC<Props> = ({
  isOpen,
  loading,
  attention,
  onClose,
  onDownloadAttachment,
}) => (
  <AppModal
    isOpen={isOpen}
    onClose={onClose}
    title="注意事項"
    maxWidth="max-w-2xl"
    centered
    footer={null}
  >
    {loading ? (
      <div className="flex items-center justify-center h-32">
        <AppSpin size="large" />
      </div>
    ) : attention ? (
      <div className="space-y-3">
        {attention.remarks && (
          <div
            dangerouslySetInnerHTML={{ __html: attention.remarks }}
            className="text-lg break-words text-[475467] line-clamp-5 max-h-[7.5em] overflow-hidden"
          />
        )}

        <div className="p-5 bg-[#f9fafa]">
          <div className="mb-4">
            <AppTypography.P className="font-bold">
              ■添付ファイルを使用する場合は自身のパソコンにデータを保存してください。
            </AppTypography.P>
          </div>

          <div className="space-y-2">
            {attachmentItems.map(item => (
              <AttachmentRow
                key={item.key}
                label={item.label}
                filename={attention[item.key]}
                onDownload={() => onDownloadAttachment(item.key)}
              />
            ))}
          </div>
        </div>
      </div>
    ) : null}
  </AppModal>
);
